import { useState, useCallback } from "react";

const STORAGE_KEY = "midship:hideSourceDocCitations";

function getStoredValue(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "true";
  } catch {
    return false;
  }
}

export function useHideSourceDocCitations(): [
  boolean,
  (value: boolean) => void,
] {
  const [hideSourceDocs, setHideSourceDocsState] = useState(getStoredValue);

  const setHideSourceDocs = useCallback((value: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // ignore
    }
    setHideSourceDocsState(value);
  }, []);

  return [hideSourceDocs, setHideSourceDocs];
}
